export default __webpack_public_path__ + "static/media/about_payment-card-transaction.f0751759.png";